/**
 * @desc 订单明细
 */
const URL = "/rantion-oms";
import http, { updateResponse } from "@/http";
export function request(params: API.oms.systemOrderItem.getOrderItemDetail.Params, options?: any) {
  return updateResponse(
    http(URL + `/systemOrderItem/getOrderItemDetail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
